import { getApiUrl } from "./apiConfig";

/**
 * Uploads a file to the backend server and returns the public URL.
 * @param file The file to upload (e.g. from an <input type="file" />)
 * @returns A promise that resolves to the URL of the uploaded file.
 */
export async function uploadFile(file: File): Promise<string> {
  const API_URL = getApiUrl();
  const formData = new FormData();
  formData.append("file", file);

  const token = localStorage.getItem('kaynin_auth_token');
  const headers: HeadersInit = {};
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const response = await fetch(`${API_URL}/upload.php`, {
    method: 'POST',
    headers,
    body: formData,
  });

  if (!response.ok) {
    throw new Error(`Erreur réseau: ${response.status} ${response.statusText}`);
  }

  const data = await response.json();
  
  if (data.error) {
    throw new Error(data.error);
  }

  return data.url;
}
